import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-powerDs",
  "use": "icon-powerDs-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-powerDs\"><title>画板 1</title><polygon points=\"865.07 433.02 433.43 433.02 542.42 0 158.93 572.4 546.11 572.4 348.83 1024 865.07 433.02\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/powerDs.svg
// module id = 1/n2
// module chunks = 54